export default {
  init() {

    // JavaScript to be fired on the home page
    
    $(document).ready(function(e){
      var o = e('.owl-carousel');
      767.98 <= e(window).width()
          ? o.owlCarousel({
                loop: 1,
                center: 0,
                callbacks: 1,
                items: 1,
                dots: 1,
                autoplayTimeout: 6e3,
                autoplay: 1,
                lazyLoad:true,
                dotsContainer: '#custom-owl-dots',
                autoplayHoverPause: 0,
                mouseDrag: 0,
                touchDrag: 1,
                nav: 0,
            })
          : o.owlCarousel({ 
                loop: 1,
                center: 0,
                callbacks: 1,
                items: 1,
                dots: 1,
                autoplayTimeout: 6e3,
                autoplay: 1,
                stagePadding: -20,
                dotsContainer: '#custom-owl-dots',
                autoplayHoverPause: 1,
                mouseDrag: 0,
                nav: 0,
                lazyLoad:true,
            });

      //Owl Nav    
      $('.owl-dot').click(function () {
        o.trigger('to.owl.carousel', [$(this).index(), 300]);
        o.trigger('stop.owl.autoplay');
        o.trigger('play.owl.autoplay');
      });    

      $('.owl-carousel .owl-lazy').each( function() {
        var screenSize = $(window).width();
        var mobileImage = $(this).attr('mobile-image');
        var desktopImage = $(this).attr('desktop-image');
        if(screenSize <= 767.98) {
          $(this).addClass('item-mobile');
          $(this).attr('data-src', mobileImage);
          $(this).css('background-image', 'url(' + mobileImage + ')');
        } else {
          $(this).addClass('item');
          $(this).attr('data-src', desktopImage);
          $(this).css('background-image', 'url(' + desktopImage + ')');
        }
      });

    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js